import { stringify } from '@portal/components'

/**
 * A function to format an unknown value into a string for displaying
 */
export function valueRenderer(
  value: unknown,
  formatObjectString?: boolean,
): string {
  if (value === null || value === undefined) {
    return ''
  }

  if (Array.isArray(value) || typeof value === 'object') {
    return formatObjectString ? stringify(value, null, 2) : stringify(value)
  }

  if (typeof value === 'boolean') {
    return `${value}`
  }

  return (value as string) ?? ''
}
